type PlatformList = {
  [key: string]: string
}

export default function getPlatform(): string {
  const platformList: PlatformList = {
    'Windows NT 10.0': 'Windows 10',
    'Windows NT 6.2': 'Windows 8',
    'Windows NT 6.1': 'Windows 7',
    'Windows NT 6.0': 'Windows Vista',
    'Windows NT 5.1': 'Windows XP',
    'Windows NT 5.0': 'Windows 2000',
    Android: 'Android',
    iPhone: 'iOS',
    iPad: 'iOS',
    iPod: 'iOS',
    Mac: 'MacOS',
    Linux: 'Linux',
    X11: 'UNIX',
  }

  for (const platform in platformList) {
    if (window.navigator.userAgent.includes(platform)) {
      return platformList[platform]
    }
  }

  return 'NA'
}
